"use client";

import { Box, Typography } from "@mui/material";
import { FC } from "react";

export const NoClipSharesDisplay: FC<{ backgroundColor: string }> = ({ backgroundColor }) => {
  return (
    <Box 
    className="p-4 flex flex-col items-center justify-center rounded-lg"
    style={{ backgroundColor }}
  >
    <Typography 
      variant="body1" 
      color="text.secondary"
      className="font-medium mb-1"
    >
      Folder has no bookmarks
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Add clips to this folder to see them here
    </Typography>
  </Box>
  );
};